import {createContext} from "react";

// Kept apart from Context.js on purpose: Context.js imports the locales, so in dev every
// locale edit re-ran it and created a new, empty context while the mounted provider still held
// the old one (consumers then read undefined: language, switchCompany…). This module imports
// nothing that changes, so the context object stays the same across hot reloads.
const roadContext = createContext({})

export {roadContext}
